/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import closeIcon from '../../img/admin/icon_close.png';

//검색된 배차기사 목록  팝업창
const FoundDriverForSelect = ({varOpenFindDriver,setOpenFindDriver,varSearchDriverList,SelectedDriverAmongFound}) => {
  return varSearchDriverList?.length===0?null:(
    <div className="poplayerDriver" style={varOpenFindDriver?{display:"block"}:{display:"none"}}>
      <div className= "display-area">
        <div className="date-right-close"><img src={closeIcon} alt="" onClick={()=>setOpenFindDriver(false)}/></div>
        <div className="consbox2">
          <div style={{fontSize:"18px"}}>검색된 차량</div>
          <select size="5" onChange={(e)=>SelectedDriverAmongFound(e)}>
            <option value={0} style={{padding:"5px 0px",whiteSpace:"pre"}}>차량 선택</option>
            {varSearchDriverList.map((driver,i)=>(
              <option key={'driver_'+i} style={{padding:"5px 0px",whiteSpace:"pre"}} value={driver.dr_mem_idx}>{driver.dr_carnumb}&nbsp;{`(${driver.mem_name})`}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
export default FoundDriverForSelect;